/* eslint-disable import/prefer-default-export */
import * as Ladda from 'ladda';


export class InfoForm {
    constructor(options) {
        const infoForm = $('#info_form');
        const infoSaveButton = $('#info_save_button');
        const errorsPlaceholder = $('#messages');

        infoForm.on('keyup', ':input', (e) => {
            if (e.keyCode === 13) {
                infoSaveButton.trigger('click');
            }
        });

        infoSaveButton.on('click', (e) => {
            e.preventDefault();

            const l = Ladda.create(infoSaveButton[0]);
            l.start();

            const postData = infoForm.find(':input').serialize();
            $.post(`${options.controller_url}update`, postData, (data) => {
                if (data) {
                    if (data.msg) {
                        if (data.msg.code === 0) {
                            errorsPlaceholder.removeClass('invalid-feedback');
                            errorsPlaceholder.addClass('valid-feedback');
                        } else {
                            errorsPlaceholder.removeClass('valid-feedback');
                            errorsPlaceholder.addClass('invalid-feedback');
                        }
                        errorsPlaceholder.removeClass('hidden').html(data.msg.text);
                        return;
                    }

                    if (data.url) {
                        window.location.href = data.url;
                    }
                }
            })
                .always(() => {
                    l.stop();
                });
        });
    }
}
